import { asMultiStyleConfig } from '../../utils/theme';
export var parts = ['item', 'command', 'list', 'button', 'groupTitle', 'divider'];
var baseStyleList = {
  bg: "#fff",
  boxShadow: '0 0 8px 0 rgba(0,0,0,0.1), 0 0 40px 0 rgba(0,0,0,0.12)',
  color: 'inherit',
  minW: '3xs',
  zIndex: 1,
  borderRadius: 'md'
};
var baseStyleItem = {
  py: [4, 4, 2],
  px: '4',
  color: 'blue.600',
  fontSize: 'md',
  fontWeight: 'semibold',
  transition: 'background 50ms ease-in 0s',
  _focus: {
    bg: "blue.1140",
    outline: 'none'
  },
  _hover: {
    bg: 'blue.1140'
  },
  _active: {
    bg: "blue.1140"
  },
  _expanded: {
    bg: "gray.100"
  },
  _disabled: {
    opacity: 0.4,
    bg: 'inherit',
    cursor: 'not-allowed'
  },
  _notLast: {
    borderBottom: '1px solid #F0F0F0'
  }
};
var baseStyleGroupTitle = {
  mx: 4,
  my: 2,
  fontWeight: 'semibold',
  fontSize: 'sm'
};
var baseStyleCommand = {
  opacity: 0.6
};
var baseStyleDivider = {
  border: 0,
  borderBottom: '1px solid #F0F0F0',
  my: '0.5rem',
  opacity: 0.6
};
export var baseStyle = {
  list: baseStyleList,
  item: baseStyleItem,
  groupTitle: baseStyleGroupTitle,
  command: baseStyleCommand,
  divider: baseStyleDivider
};
export default asMultiStyleConfig({
  parts,
  baseStyle
});